

export default function MentionsLegalesPage() {
    return (
        <div className="min-h-screen bg-background">

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="max-w-4xl mx-auto">
                    <h1 className="text-3xl md:text-4xl font-semibold text-foreground mb-8">
                        Mentions légales
                    </h1>

                    <div className="prose prose-slate max-w-none space-y-6 text-muted-foreground">
                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                1. Informations sur l'entreprise
                            </h2>
                            <p>
                                Le site web <strong>dendromap.fr</strong> est édité par :
                            </p>
                            <ul className="list-none space-y-2 ml-4">
                                <li><strong>Raison sociale :</strong> RACINES ET CIMES</li>
                                <li><strong>Directeur de publication :</strong> Grégory SIMON</li>
                                <li><strong>Forme juridique :</strong> [À compléter]</li>
                                <li><strong>Capital social :</strong> [À compléter]</li>
                                <li><strong>SIRET :</strong> [À compléter]</li>
                                <li><strong>RCS :</strong> [À compléter]</li>
                                <li><strong>Adresse du siège social :</strong> [À compléter]</li>
                                <li><strong>Téléphone :</strong> [À compléter]</li>
                                <li><strong>E-mail :</strong> <a href="mailto:contact@dendromap.fr" className="text-primary hover:underline">contact@dendromap.fr</a></li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                2. Directeur de publication
                            </h2>
                            <p>
                                Le directeur de publication est <strong>Grégory SIMON</strong>, arboriste passionné et créateur de l'application innovante DENDROMAP.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                3. Hébergement
                            </h2>
                            <p>
                                Le site est hébergé par :
                            </p>
                            <ul className="list-none space-y-2 ml-4">
                                <li><strong>Hébergeur :</strong> [Nom de l'hébergeur]</li>
                                <li><strong>Adresse :</strong> [Adresse de l'hébergeur]</li>
                                <li><strong>Téléphone :</strong> [Téléphone de l'hébergeur]</li>
                                <li><strong>Site web :</strong> <a href="#" className="text-primary hover:underline">[Site de l'hébergeur]</a></li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                4. Propriété intellectuelle
                            </h2>
                            <p>
                                L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes, etc.) est la propriété exclusive de RACINES ET CIMES, sauf mention contraire.
                            </p>
                            <p>
                                Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable de RACINES ET CIMES.
                            </p>
                            <p>
                                Toute exploitation non autorisée du site ou de son contenu engage la responsabilité civile et/ou pénale de l'utilisateur et pourra donner lieu à des poursuites judiciaires.
                            </p>
                            <p>
                                Les marques, logos et signes distinctifs présents sur le site sont la propriété de RACINES ET CIMES ou de leurs partenaires. Toute reproduction non autorisée de ces éléments est interdite.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                5. Responsabilité
                            </h2>
                            <p>
                                RACINES ET CIMES s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site, dont elle se réserve le droit de corriger, à tout moment et sans préavis, le contenu.
                            </p>
                            <p>
                                Cependant, RACINES ET CIMES ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
                            </p>
                            <p>
                                En conséquence, RACINES ET CIMES décline toute responsabilité :
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>pour toute interruption du site</li>
                                <li>pour toute survenance de bugs</li>
                                <li>pour toute inexactitude ou omission portant sur des informations disponibles sur le site</li>
                                <li>pour tout dommage résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations mises à disposition sur le site</li>
                                <li>et plus généralement pour tout dommage, direct ou indirect, quelles qu'en soient les causes, origines, nature ou conséquences, provoqué à raison de l'accès de quiconque au site ou de l'impossibilité d'y accéder</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                6. Liens externes
                            </h2>
                            <p>
                                Le site peut contenir des liens hypertextes vers d'autres sites présents sur le réseau Internet. Les liens vers ces autres ressources vous font quitter le site dendromap.fr.
                            </p>
                            <p>
                                Il est possible de créer un lien vers la page de présentation de ce site sans autorisation expresse de l'éditeur. Aucune autorisation ni demande d'information préalable ne peut être exigée par l'éditeur à l'égard d'un site qui souhaite établir un lien vers le site de l'éditeur. Il convient toutefois d'afficher ce site dans une nouvelle fenêtre du navigateur.
                            </p>
                            <p>
                                RACINES ET CIMES ne peut être tenue responsable du contenu et des pratiques de ces sites externes.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                7. Protection des données personnelles
                            </h2>
                            <p>
                                Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
                            </p>
                            <p>
                                Pour exercer ce droit, vous pouvez nous contacter à l'adresse : <a href="mailto:contact@dendromap.fr" className="text-primary hover:underline">contact@dendromap.fr</a>
                            </p>
                            <p>
                                Pour plus d'informations, consultez notre <a href="/politique-de-confidentialite" className="text-primary hover:underline">Politique de confidentialité</a>.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                8. Cookies
                            </h2>
                            <p>
                                Le site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. En continuant à naviguer sur ce site, vous acceptez l'utilisation de cookies.
                            </p>
                            <p>
                                Pour plus d'informations sur l'utilisation des cookies, consultez notre <a href="/politique-de-confidentialite" className="text-primary hover:underline">Politique de confidentialité</a>.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                9. Droit applicable et juridiction compétente
                            </h2>
                            <p>
                                Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux français conformément aux règles de compétence en vigueur.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">
                                10. Contact
                            </h2>
                            <p>
                                Pour toute question concernant ces mentions légales, vous pouvez nous contacter :
                            </p>
                            <ul className="list-none space-y-2 ml-4">
                                <li><strong>Par e-mail :</strong> <a href="mailto:contact@dendromap.fr" className="text-primary hover:underline">contact@dendromap.fr</a></li>
                                <li><strong>Par courrier :</strong> RACINES ET CIMES, [Adresse complète]</li>
                            </ul>
                        </section>

                        <div className="mt-8 pt-6 border-t border-border">
                            <p className="text-sm text-muted-foreground">
                                <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

